import api from "./base";

export const CREATE_OTP = `/auth/otp/create`;
export const VALIDATE_OTP = `/auth/otp/validate`;
export const DELETE_TOKEN = `/auth/token/delete`;

export async function createOTP(phoneNumber) {
    const res = await api.post(CREATE_OTP, { phoneNumber });
    return res.data;
}

export async function validateOTP(phoneNumber, otp) {
    const res = await api.post(VALIDATE_OTP, { phoneNumber, otp: Number(otp) });
    return res.data;
}

export async function destroyToken(token) {
    const res = await api.delete(DELETE_TOKEN, {
        headers: { Authorization: `Bearer ${token}` },
        data: { token },
    });
    return res.data;
} 